var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',{staticClass:"dashboard",staticStyle:{"background-color":"#F0F0F0"},attrs:{"title":"Aktivitet"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.topic),expression:"topic"}],staticClass:"tool-text",attrs:{"slot":"tools","placeholder":"Emne","type":"text"},domProps:{"value":(_vm.topic)},on:{"input":function($event){if($event.target.composing)return;_vm.topic=$event.target.value}},slot:"tools"}),_c('new-table-view',{staticClass:"list",attrs:{"columns":[
			{
				label: 'Modtaget',
				name: 'created',
				filter: 'timestamp_s'
			},
			{
				label: 'Afsender',
				name: ['_computed', 'client', ]
			},
			{
				label: 'Emne',
				name: 'topic'
			},
			{
				label: 'Payload',
				name: 'payload',
				weight: '2fr'
			},
			{
				label: '',
				name: 'resend',
				align: 'right',
				template: {
					name: 'button',
					label: 'Gensend'
				}
			}
		],"items":_vm._items},on:{"itemClick":_vm.itemClick,"resend":_vm.itemResend}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }